package org.example.project.dashboard

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableLongStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import org.example.project.service.GlobalManager

val LocalScreenRefreshVersion = compositionLocalOf { 0L }
val LocalScreenReload = compositionLocalOf<(() -> Unit)?> { null }

@Composable
fun TrackedScreenHost(
    screen: org.example.project.utils.All,
    content: @Composable () -> Unit
) {
    val refreshVersion = GlobalManager.screenVersion(screen.key)
    var reloadVersion by remember(screen.key) { mutableLongStateOf(0L) }

    DisposableEffect(screen.key) {
        GlobalManager.mountScreen(screen.key)
        onDispose {
            GlobalManager.unmountScreen(screen.key)
        }
    }

    CompositionLocalProvider(
        LocalScreenRefreshVersion provides refreshVersion,
        LocalScreenReload provides { reloadVersion++ }
    ) {
        key(screen.key, reloadVersion) { content() }
    }
}
